export type CareerOutputModel = {
  city: string; //*
  closingDate: string | null;
  code: string;
  contactInformation: string | null;
  country: string | null; //*
  currency: string; //*
  educationLevel: string;
  id: string;
  isEditSalary: boolean;
  jobDescription: string; //*
  languageId: string;
  maxSalary: number | null;
  minSalary: number | null;
  requirementsBenefits: string | null;
  status: CareerStatus;
  title: string; //*
  vacancies: number; //*
  avatar: string;
};

export enum CareerStatus {
  PUBLISH = "publish",
  UNPUBLISH = "unpublish",
}

export enum EducationLevelStatus {
  ANY_LEVEL = "any_level",
  HIGH_SCHOOL_OR_EQUIVALENT = "high_school_or_equivalent",
  ASSOCIATE_DEGREE = "associate_degree",
  BACHELOR_DEGREE = "bachelor_degree",
  MASTER_DEGREE = "master_degree",
  DOCTORATE_DEGREE = "doctorate_degree",
  NONE = "none",
}

export enum CurrencyStatus {
  VND = "VND",
  CNY = "CNY",
  EUR = "EUR",
  USD = "USD",
  GBP = "GBP"
}
